import React from "react";
import {
    DashboardOutlined as Dashboard,
    HomeOutlined as Home,
    DescriptionOutlined as Description,
    PeopleOutlined as People,
    SettingsOutlined as Settings,
    BugReportOutlined as BugReport,
    FeedbackOutlined as Feedback,
    AdminPanelSettingsOutlined as AdminPanelSettings,
    WorkOutlineOutlined as Work,
    AnalyticsOutlined as AssessmentIcon,
    FactCheckOutlined as RateReviewIcon,
} from "@mui/icons-material";

export const menuConfig = {
    superadmin: [
        // { text: "Dashboard", icon: <Dashboard />, path: "/superadmin/landing" },
        { text: "Tenant Management", icon: <AdminPanelSettings />, path: "/tenant/management" },
        { text: "Demo Requests", icon: <People />, path: "/superadmin/demo-requests" },
        { text: "Feedback", icon: <Feedback />, path: "/feedback/display" },
        { text: "Settings", icon: <Settings />, path: "/superadmin/plan-setting" },
    ],
    admin: [
        { text: "Dashboard", icon: <Dashboard />, path: "/admin/dashboard" },
        { text: "User Management", icon: <AdminPanelSettings />, path: "/recruiter/management" },
        { text: "Share Feedback", icon: <RateReviewIcon />, path: "/feedback" },
        { text: "Plan and Usage", icon: <AssessmentIcon />, path: "/admin-settings" },
        { text: "Configurations", icon: <Settings />, path: "/admin/config" },

    ],
    freelancer: [
        { text: "Dashboard", icon: <Dashboard />, path: "/recruiter/dashboard" },
        { text: "Jobs", icon: <Home />, path: "/recruiter/landing" },
        { text: "Interview Reports", icon: <Description />, path: "/interview/report" },
        // { text: "Careers", icon: <Work />, path: "/user/landing" },
        { text: "Share Feedback", icon: <RateReviewIcon />, path: "/feedback" },
        { text: "Plan and Usage", icon: <AssessmentIcon />, path: "/admin-settings" },
    ],
    recruiter: [
        { text: "Dashboard", icon: <Dashboard />, path: "/recruiter/dashboard" },
        { text: "Jobs", icon: <Home />, path: "/recruiter/landing" },
        { text: "Interview Reports", icon: <Description />, path: "/interview/report" },
        { text: "Share Feedback", icon: <RateReviewIcon />, path: "/feedback" },
        // { text: "Plan and Usage", icon: <AssessmentIcon />, path: "/recruiter-settings" },
    ],

    user: [
        { text: "Careers", icon: <Work />, path: "/user/landing" },
        { text: "Share Feedback", icon: <RateReviewIcon />, path: "/feedback" },
    ]
};

export const ALLOWED_ROUTES_BY_ROLE = {
    superadmin: [
        "/tenant/management",
        "/tenant/token/detail",
        "/superadmin/demo-requests",
        "/tenant/details",
        "/tenant/onboarding",
        "/feedback/display",
        "/superadmin/plan-setting",
    ],
    admin: [
        "/admin/dashboard",
        "/recruiter/management",
        "/feedback",
        "/admin-settings",
        "/admin/config",
    ],
    recruiter: [
        "/recruiter/dashboard",
        "/recruiter/landing",
        "/interview/report",
        "/feedback",
        "/settings",
        "/recruiter-settings",
        "/resume/analysis",
        "/generate/question",
        "/recruiter/analysis",
        "/reports/candidates",
        "/reports/candidates/detail",
        "/recruiter/llm-matching",
        "/recruiter/jd-generator",
        "/recruiter/questions",
    ],
    freelancer: [
        "/recruiter/dashboard",
        "/recruiter/landing",
        "/interview/report",
        "/feedback",
        "/admin-settings",
        "/settings",
        "/recruiter-settings",
        "/resume/analysis",
        "/generate/question",
        "/recruiter/analysis",
        "/reports/candidates",
        "/reports/candidates/detail",
        "/recruiter/llm-matching",
        "/recruiter/jd-generator",
        "/recruiter/questions",
    ],
    user: [
        "/user/landing",
        "/feedback",
    ],
};